import { Sale } from "gen/txn/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchSalesV2 } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useSaleFilter({
  key = "sale",
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "initialSelectedOptions"
  >
> = {}) {
  const { results, setQuery, loadNext } = useSearchSalesV2()

  const sales = useMemo(() => {
    const sales: Sale[] = []
    for (const { sale } of results) {
      if (!sale) continue
      sales.push(sale)
    }
    return sales
  }, [results])

  const { filter, selected: selectedSaleIds } = useIdFilter({
    key,
    label: "Sale",
    values: sales,
    labelExtractor: (sale) => sale.identifier,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    onLoadMore: loadNext,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedSaleIds }
}
